<template>
  <section class="w-full bg-(--main-color-800) my-40">
    <div class="lg:grid lg:grid-cols-2 items-center">
      <div class="relative w-full col-span-2 md:col-span-1">
        <img
          id="burger"
          :src="`/images/burger.webp`"
          alt="image de burger"
          class="w-full lg:w-auto lg:max-w-none lg:absolute lg:right-[100px] lg:top-1/4 lg:transform lg:-translate-y-1/2 hidden md:block"
          loading="lazy"
          decoding="async"
          width="547"
          height="547"
        />
      </div>

      <div class="p-8">
        <h2 class="text-white dark:text-white text-4xl lg:max-w-xl max-w-none">
          Preparez votre panier, commandez et nous vous livrons
        </h2>

        <p class="text-white dark:text-gray-200 mt-5 lg:max-w-2xl max-w-none">
          Pour mieux profiter des aventages de notre platforme, vous pouvez cree
          un compte afin d'avoir les aventages sur votre profile tels que les
          points de fidelite, historique de commande, etc...
        </p>
        <UButton
          color="white"
          :ui="{
            rounded: 'rounded-full',
            size: 'xl',
          }"
          class="mt-4 text-(--main-color-900) dark:text-(--main-color-900) hover:cursor-pointer"
          >Mon compte</UButton
        >
      </div>
    </div>
  </section>
</template>

<script setup></script>

<style></style>
